import { IAiAssistantContent } from '../../views/Pages/AiAssistant/models/ai-assistant.models';

export const AI_TOOLS_CONTENT_UPDATE = '[ACTION] AI_TOOLS_CONTENT_UPDATE';
export const AI_TOOLS_OPEN = '[ACTION] AI_TOOLS_OPEN';

export function openAiTools(aiToolsOpen: boolean) {
	return {
		type: AI_TOOLS_OPEN,
		payload: { aiToolsOpen },
	};
}

export function updateAiAssistantContent(partial: Partial<IAiAssistantContent>) {
	window.dispatchEvent(new CustomEvent(AI_TOOLS_CONTENT_UPDATE));

	return {
		type: AI_TOOLS_CONTENT_UPDATE,
		payload: { aiAssistantContent: partial },
	};
}
